import axios from 'axios'

export type DemoResetScheduleResponse = {
  data: {
    enabled: boolean
    server_time: string
    timezone: 'UTC'
    next_reset_at: string | null
    interval_minutes: number | null
  }
}

export const getDemoResetSchedule = async (): Promise<
  DemoResetScheduleResponse['data']
> => {
  const { data } = await axios.get<DemoResetScheduleResponse>(
    'demo/reset-schedule',
    {
      baseURL: import.meta.env.VITE_API_URL,
      headers: { 'Cache-Control': 'no-cache' },
    },
  )

  return data.data
}
